export default __webpack_public_path__ + "static/media/NOCOUNTRY.73fdb5ee.svg";